var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"close",on:{"click":_vm.returnHistory}},[_c('img',{attrs:{"src":require("../../assets/img/registrationLogin/close.png"),"alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }